import { Component, inject } from '@angular/core';
import { SecondaryLogoComponent } from '../../components/shared/secondary-logo/secondary-logo.component';
import { NgOptimizedImage } from '@angular/common';
import { AppRoutes } from '../../utils/enums/routes.enum';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-inactive-link-page',
  standalone: true,
  imports: [SecondaryLogoComponent, NgOptimizedImage, TranslatePipe],
  templateUrl: './inactive-link-page.component.html',
  styleUrl: './inactive-link-page.component.scss',
})
export class InactiveLinkPageComponent {
  private readonly router = inject(Router);
  public readonly appRoutes = AppRoutes;

  public returnToLogin(): void {
    this.router.navigate([this.appRoutes.LOGIN]);
  }
}
